import React from 'react';

function NotySuccessIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="45"
      fill="none"
      viewBox="0 0 44 45"
    >
      <g>
        <path
          fill="#04D800"
          d="M16.503 20.169c-1.164 0-1.94-.804-1.94-2.01V9.722c0-1.205.776-2.009 1.94-2.009 1.163 0 1.939.804 1.939 2.01v8.438c0 1.004-.97 2.009-1.94 2.009zm12.797-2.01V9.722c0-1.205-.775-2.009-1.939-2.009-1.163 0-1.939.804-1.939 2.01v8.438c0 1.205.776 2.009 1.94 2.009 1.163 0 1.938-1.005 1.938-2.01zm8.92 10.85c.582-1.005.194-2.21-.582-2.813-1.163-.402-2.327-.2-2.908.804-2.133 3.616-7.369 6.027-12.992 6.027-5.429 0-10.47-2.21-12.797-5.625-.582-1.005-1.745-1.206-2.715-.603-.776.804-.97 2.009-.388 2.813 3.103 4.62 9.114 7.433 15.9 7.433 7.175 0 13.573-3.013 16.482-8.036z"
        ></path>
      </g>
    </svg>
  );
}

export default NotySuccessIcon;
